module.exports = __webpack_public_path__ + "img/img-banner-01.72cc64b5.png";